export default __webpack_public_path__ + "687155dfaba9b9077eabb91110616b79.webp";